import { schema } from "normalizr";

export const exchangeSchema = new schema.Entity("exchange", {});
export const arrayOfExchangeSchemas = new schema.Array(exchangeSchema);
